import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csconstruct(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Constructor tutorial For Beginners</title>
 <meta name="description" content="C# constructor tutorial for beginners.why we use constructor in c# because The main use of constructor initializes an object.constructor in c# has no return type and no use void because of unexpressed return type value of a class" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# constructor,c# constructor for,c sharp constructor,c# constructor for loop,c# exit for loop,exit while loop c#,c# continue,constructor foreach c#,c# foreach constructor" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-constructor" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Constructor in Csharp(C#)</h1>
    <div className="first">
        <a href="/csharp-object-initializers">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-inheritance">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Q-what is a Constructor in c# and why we use a constructor in C# ?
</h2>

<p className="mt-3 para">Ans- why we use a constructor in c# because The main use of constructor initializes an object 
constructor in c# has no return type and no use void because of unexpressed return type value of a class<br/>
Constructor execute  automatically  when we create an object
 
</p>



<h2 className='headings'>Q-Write a Program Constructor in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-5">Construct </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">int </span>
            <span className="qwerty">a</span>
            <span className="qwerty-5">; </span>
            {"\n"}
            <span className="qwerty-5">Construct</span>
            <span className="qwerty-3">()</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">a</span>
            <span className="qwerty-5"> = </span>
            <span className="qwerty-4">40</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-3">mainClass </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Construct </span>
            <span className="qwerty-7">c1</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">new</span>
            <span className="qwerty-5"> Construct</span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">Construct </span>
            <span className="qwerty-7">c2</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">new</span>
            <span className="qwerty-5"> Construct</span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-7">c1.a</span>
            <span className="qwerty-6"> +" "+ </span>
            <span className="qwerty-7">c2.a</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-7">40 </span>
              <span className="qwerty-4">40 </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h2 className="mt-4 mh2">There are 3 types of constructor in c#:
</h2>
<p className="mt-4 para">1, Default constructor in c#<br/>
2, user-defined constructor(no-argument constructor in c#)<br/>
3, parameterized constructor <br/></p>

<h2 className="mt-4 mh2">1,Default Constructor in c#:</h2>
<p className="mt-4 para"> Default constructor in c# The compiler creates automatically a constructor if you do not create a constructor and this is no-argument constructor this is known as <span className="bold"> default constructor</span>
</p>



<h2 className='headings'>Q-Write a Program Default constructor in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-5">def </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">def</span>
            <span className="qwerty-1">()</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-6">Hello default constructor in code exampler</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-2">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">def </span>
            <span className="qwerty-7">na</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">new</span>
            <span className="qwerty-5"> def</span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-6">Hello default constructor in code exampler</span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h2 className="mt-4 mh2">Important:</h2>
<p className="mt-4 para">Constructor create automatically by the compiler if you do not create constructor name of the default
</p>
<h2 className="mt-4 mh2">2, No argument constructor in C#:
</h2>

<p className="mt-4 para">no Argument constructor in C# the user create constructor means this constructor create my own or user and this is also a <span className="bold"> no-argument constructor</span></p>



<h2 className='headings'>Q-Write a Program no argument constructor in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-5">noarg </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">noarg</span>
            <span className="qwerty-5">()</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-6">This is no Argument constructor in code Exampler</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-2">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">noarg </span>
            <span className="qwerty-7">na</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">new</span>
            <span className="qwerty-5"> noarg</span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-6">This is no Argument constructor in code Exampler</span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h2 className="mt-4 mh2">3, Parameterized constructor:</h2>
<p className="mt-4 para"> Parameterized constructor in c# user create constructor means this constructor create my own or use and also pass parametrize
</p>



<h2 className='headings'>Q-Write a Program Parameterized constructor in C# example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty-5">para </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">int </span>
            <span className="qwerty">no</span>
            <span className="qwerty-5">; </span>
            {"\n"}
            <span className="qwerty-5">para </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-5">int i</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">this.no</span>
            <span className="qwerty-5"> = </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-2">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">para </span>
            <span className="qwerty-7">pa</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">new</span>
            <span className="qwerty-5"> para</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">10</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-6">Number is:</span>
            <span className="qwerty-7">"+</span>
            <span className="qwerty-7">pa.no</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-6">Number is:</span>
              <span className="qwerty-4">10 </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-object-initializers">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-inheritance">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csconstruct;